import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { WindowPortal } from '../../../custom_shared/components';
import { useExternalWindow } from '../../../custom_shared/hooks';
import { DocumentVisualStore } from '../../../documents/stores';
import { DocumentPreviewStore } from '../../stores';
import { IAppStoreBase, ISessionStoreBase } from '../../types';
import SideDocumentPreview from './SideDocumentPreview';
import FullScreenDocumentPreview from './FullScreenDocumentPreview';

interface Props {
    appStore: IAppStoreBase;
    sessionStore: ISessionStoreBase;
    documentVisualStore: DocumentVisualStore;
    documentPreviewStore: DocumentPreviewStore;
    lightMode?: boolean;
    showPageNumbers?: boolean;
}

const DocumentPreview: React.FC<Props> = ({
    appStore,
    sessionStore,
    documentVisualStore,
    documentPreviewStore,
    lightMode,
    showPageNumbers
}) => {
    const { externalWindow, setExternalWindow } = useExternalWindow();

    if (documentPreviewStore.previewPosition === 'fullScreen') {
        return (
            <WindowPortal
                title="Document Preview"
                externalWindow={externalWindow}
                setExternalWindow={setExternalWindow}
                onWindowClose={() => {
                    documentPreviewStore.setPreviewPosition('rightSide');
                    setExternalWindow(undefined);
                }}
            >
                <FullScreenDocumentPreview
                    appStore={appStore}
                    sessionStore={sessionStore}
                    documentPreviewStore={documentPreviewStore}
                    documentVisualStore={documentVisualStore}
                    externalWindow={externalWindow}
                    lightMode={lightMode}
                />
            </WindowPortal>
        );
    }

    return (
        <SideDocumentPreview
            appStore={appStore}
            sessionStore={sessionStore}
            documentVisualStore={documentVisualStore}
            documentPreviewStore={documentPreviewStore}
            lightMode={lightMode}
            showPageNumbers={showPageNumbers}
        />
    );
};

export default observer(DocumentPreview);
